<template>
  <div class="message">
    {{ `Your next session begins in ${timeLeft} minutes.` }}
  </div>
  <!-- <div v-if="sessionIsMatched" class="message">
    {{ `Your next session begins in ${timeLeft} minutes.` }}
  </div>
  <div v-else class="message">
    {{ `Your next session begins in ${timeLeft} minutes. No partner yet...` }}
  </div> -->
</template>


<script>
export default {
  name: "TimerTenToStartMessage",
  props: ["sessionIsMatched", "timeLeft"],
};
</script>
